import { render } from "./CardCompliance.vue?vue&type=template&id=5e53157d"
import script from "./CardCompliance.vue?vue&type=script&lang=js"
export * from "./CardCompliance.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__